<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '';
    export let placeholder: string = '';
    export let disabled: boolean = false;
    export let required: boolean = false;
    export let rows: number = 4;

    errors[name] = [];

    const validate = (val: string = value) => {
        errors[name] = [];
        if (required && !val.trim()) {
            errors[name].push('This field is required');
        }
    };
    validate();

    const handleInput = (e: Event) => validate((e.currentTarget as HTMLTextAreaElement).value);

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <textarea
        {name}
        {placeholder}
        {disabled}
        {required}
        {rows}
        bind:value
        on:input={handleInput}
        class:error={errors[name].length > 0}
        on:change
        on:blur
    ></textarea>
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
